import {
  GET_QUESTIONTYPES,
  GET_QUESTIONTYPES_SUCCESS,
  GET_QUESTIONTYPES_FAIL,
  GET_QUESTION_DETAIL,
  GET_QUESTION_DETAIL_SUCCESS,
  GET_QUESTION_DETAIL_FAIL,
  ADD_QUESTION_RESPONSE,
  ADD_QUESTION_RESPONSE_SUCCESS,
  ADD_QUESTION_RESPONSE_FAIL,
  GET_RESPONSE_OUTCOME,
  GET_RESPONSE_OUTCOME_SUCCESS,
  GET_RESPONSE_OUTCOME_FAIL,
  GET_PROJECTS,
  GET_PROJECTS_SUCCESS,
  GET_PROJECTS_FAIL,
  GET_PROJECT_DETAIL,
  GET_PROJECT_DETAIL_SUCCESS,
  GET_PROJECT_DETAIL_FAIL,
  GET_NNS,
  GET_NNS_SUCCESS,
  GET_NNS_FAIL,
  ADD_PROJECT,
  ADD_PROJECT_SUCCESS,
  ADD_PROJECT_FAIL,
  UPDATE_PROJECT,
  UPDATE_PROJECT_SUCCESS,
  UPDATE_PROJECT_FAIL,
  GET_NNS_STRANDS,
  GET_NNS_STRANDS_SUCCESS,
  GET_NNS_STRANDS_FAIL,
  GET_AWARD_PERIODS,
  GET_AWARD_PERIODS_SUCCESS,
  GET_AWARD_PERIODS_FAIL,
} from "./actionTypes"

export const getProjects = () => ({
  type: GET_PROJECTS,
})

export const getProjectsSuccess = projects => ({
  type: GET_PROJECTS_SUCCESS,
  payload: projects,
})

export const getProjectsFail = error => ({
  type: GET_PROJECTS_FAIL,
  payload: error,
})

export const getProjectDetail = rowID => ({
  type: GET_PROJECT_DETAIL,
  rowID,
})

export const getProjectDetailSuccess = details => ({
  type: GET_PROJECT_DETAIL_SUCCESS,
  payload: details,
})

export const getProjectDetailFail = error => ({
  type: GET_PROJECT_DETAIL_FAIL,
  payload: error,
})

export const getNNS = () => ({
  type: GET_NNS,
})

export const getNNSSuccess = nnsnames => ({
  type: GET_NNS_SUCCESS,
  payload: nnsnames,
})

export const getNNSFail = error => ({
  type: GET_NNS_FAIL,
  payload: error,
})

export const addProject = project => ({
  type: ADD_PROJECT,
  payload: project,
})

export const addProjectSuccess = project => ({
  type: ADD_PROJECT_SUCCESS,
  payload: project,
})

export const addProjectFail = error => ({
  type: ADD_PROJECT_FAIL,
  payload: error,
})

export const updateProject = project => ({
  type: UPDATE_PROJECT,
  payload: project,
})

export const updateProjectSuccess = project => ({
  type: UPDATE_PROJECT_SUCCESS,
  payload: project,
})

export const updateProjectFail = error => ({
  type: UPDATE_PROJECT_FAIL,
  payload: error,
})

export const getQuestionTypes = () => ({
  type: GET_QUESTIONTYPES,
})

export const getQuestionTypesSuccess = questiontypes => ({
  type: GET_QUESTIONTYPES_SUCCESS,
  payload: questiontypes,
})

export const getQuestionTypesFail = error => ({
  type: GET_QUESTIONTYPES_FAIL,
  payload: error,
})

export const getQuestionDetail = rowID => ({
  type: GET_QUESTION_DETAIL,
  rowID,
})

export const getQuestionDetailSuccess = details => ({
  type: GET_QUESTION_DETAIL_SUCCESS,
  payload: details,
})

export const getQuestionDetailFail = error => ({
  type: GET_QUESTION_DETAIL_FAIL,
  payload: error,
})

export const addQuestionResponse = payload => ({
  type: ADD_QUESTION_RESPONSE,
  payload,
})

export const addQuestionResponseSuccess = response => ({
  type: ADD_QUESTION_RESPONSE_SUCCESS,
  payload: response,
})

export const addQuestionResponseFail = error => ({
  type: ADD_QUESTION_RESPONSE_FAIL,
  payload: error,
})

export const getResponseOutcome = payload => ({
  type: GET_RESPONSE_OUTCOME,
  payload,
})

export const getResponseOutcomeSuccess = detail => ({
  type: GET_RESPONSE_OUTCOME_SUCCESS,
  payload: detail,
})

export const getResponseOutcomeFail = error => ({
  type: GET_RESPONSE_OUTCOME_FAIL,
  payload: error,
})

export const getNNSStrands = () => ({
  type: GET_NNS_STRANDS,
})

export const getNNSStrandsSuccess = nnsstrands => ({
  type: GET_NNS_STRANDS_SUCCESS,
  payload: nnsstrands,
})

export const getNNSStrandsFail = error => ({
  type: GET_NNS_STRANDS_FAIL,
  payload: error,
})

export const getAwardPeriods = () => ({
  type: GET_AWARD_PERIODS,
})

export const getAwardPeriodsSuccess = awardperiods => ({
  type: GET_AWARD_PERIODS_SUCCESS,
  payload: awardperiods,
})

export const getAwardPeriodsFail = error => ({
  type: GET_AWARD_PERIODS_FAIL,
  payload: error,
})
